import * as React from "react";
import axios from "axios";
import Tags from "../Tagify/react.tagify";
import Tag from "../Models/Tag";

interface FilterProps {
    onSearch: () => void;
    clearFiltersText: string;
    searchButtonText: string;
    searchBoxPlaceholderText: string;
    tagsOnChanged: (e, x) => void;
    allTagsRemoved: () => void;
}

interface FilterStates {
    whitelist: any;
}

export default class Filter extends React.Component<FilterProps, FilterStates> {
    getFilterOptionsUrl: string;
    constructor(props: FilterProps) {
        super(props);

        this.state = {whitelist: []}

        this.getFilterOptionsUrl = "/api/ContentDataApi/GetArticleTileListFilterOptions";
        this.onChange = this.onChange.bind(this);
    }

    tagifySettings = {
        callbacks: {
            remove: e => { if (e.detail.tagify.value.length == 0) this.props.allTagsRemoved() }},
        dropdown: {
            enabled: 0 // always show suggestions dropdown
        },
        autoComplete: {
            enabled: true,
            rightKey: false
        },
    }

    public componentDidMount() {
        this.getFilterOptions();
    }
    
    public getFilterOptions() {
        let options = [];
        axios.get(this.getFilterOptionsUrl).then((response) => {
            if (response && response.data) {
                options = response.data.data;
                this.setState({ whitelist: options });
            } else {
                console.error("Unable to get data for content archive");
                return "";
            }
        });
        return options;
    }

    public onChange(e){
        this.props.tagsOnChanged(this.state.whitelist, e);
    }


    public render() {
        const settings = {
            ...this.tagifySettings,
            whitelist: []
        }

        for (var i = 0; i < this.state.whitelist.length; i++) {
            settings.whitelist.push(this.state.whitelist[i].Value);
        }
        
        return (
            <div className="article-list--filter col-md-6">
                <Tags mode='textarea'
                    className='article-list--tagify'
                    placeholder={this.props.searchBoxPlaceholderText}
                    id="Filters"
                    name='tags'
                    settings={settings}
                    onChange={this.onChange}
                />

                <button className="btn article-list--btn" onClick={() => {this.props.onSearch();}}>{this.props.searchButtonText}</button>
            </div>
        );
    }
}
